// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Accordion$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/hooks/Accordion.mjs";
import * as FaqAccordionItem$PorterinFeature from "../../shared/faq-accordion-item/view/FaqAccordionItem.mjs";
import * as FaqsModuleScss from "../styles/common/Faqs.module.scss";

var styles = FaqsModuleScss;

function FaqsCmp(Props) {
  var faqs_section = Props.faqs_section;
  var hide_descOpt = Props.hide_desc;
  var custom_stylesOpt = Props.custom_styles;
  var hide_desc = hide_descOpt !== undefined ? hide_descOpt : true;
  var custom_styles = custom_stylesOpt !== undefined ? custom_stylesOpt : ({});
  var match = Accordion$PorterinUtils.useAccordion(undefined);
  var accordionOnClick = match[1];
  var isActive = match[0];
  return React.createElement("div", {
              className: styles["faqs-container"],
              style: custom_styles
            }, React.createElement("h2", {
                  className: styles.header
                }, faqs_section.title), hide_desc ? null : React.createElement("div", {
                    className: styles["desc-wrapper"]
                  }, faqs_section.sub_text), React.createElement("div", {
                  className: styles["faq-wrapper"]
                }, faqs_section.faqs.map(function (faq, index) {
                      return React.createElement(FaqAccordionItem$PorterinFeature.make, {
                                  containerClass: styles["item-wrapper"],
                                  headerClass: styles.question,
                                  bodyClass: styles.answer,
                                  onClick: (function (param) {
                                      Curry._1(accordionOnClick, index);
                                    }),
                                  isActive: Curry._1(isActive, index),
                                  header: faq.question,
                                  content: faq.answer,
                                  toggle_icon: faqs_section.toggle_icon,
                                  key: faq.question
                                });
                    })));
}

var make = FaqsCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
